/**
 * global YT:true
 */
export default class EmbedYoutubeVideo {
    player = false;

    constructor(context) {
        this.context = context;

        this.id = `player${this.generateId()}`;
        this.videoId = context.getAttribute('data-youtube-id');

        this.createPlayerWhenPossible();
    }

    createPlayerWhenPossible() {
        if (this.apiReady) {
            this.createPlayer();
        } else {
            document.addEventListener(
                'youtube-api-ready',
                () => {
                    this.apiReady = true;
                    this.createPlayer();
                },
                false
            );

            if (this.apiImplemented === false) {
                this.apiImplemented = true;
                this.implementScript();
            }
        }
    }

    createPlayer() {
        this.context.id = this.id;
        this.player = new YT.Player(this.id, {
            // eslint-disable-line no-undef
            height: '340',
            width: '650',
            videoId: this.videoId,
        });
    }

    implementScript() {
        const tag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];

        tag.src = '//www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    generateId(length = 4) {
        return Math.random()
            .toString(36)
            .replace(/[^a-z]+/g, '')
            .substr(0, length);
    }

    get apiImplemented() {
        return this.constructor.api.implemented;
    }

    set apiImplemented(value) {
        this.constructor.api.implemented = value;
    }

    get apiReady() {
        return this.constructor.api.ready;
    }

    set apiReady(value) {
        this.constructor.api.ready = value;
    }
}

EmbedYoutubeVideo.api = {
    implemented: false,
    ready: false,
};

/**
 * Вызывается когда загружается Youtube API
 * Файрит кастомный ивент, на который можно привзывать свои штуки
 * (в API ютуба нельзя поменять функцию колбэк)
 */
if (typeof window.onYouTubeIframeAPIReady !== 'function') {
    window.onYouTubeIframeAPIReady = () => {
        const event = new CustomEvent('youtube-api-ready');

        document.dispatchEvent(event);
    };
}
